import log from 'loglevel';

const isDev = process.env.NODE_ENV === 'development';

log.setLevel(isDev ? 'debug' : 'warn');

/**
 * Get a logger instance with a specific name.
 */
export function makeLogger(name: string) {
	const logger = log.getLogger(name);
	const prefix = `[${name}]`;

	logger.setLevel(isDev ? 'debug' : 'info');

	return {
		debug: (...args: any[]) => logger.debug(prefix, ...args),
		info: (...args: any[]) => logger.info(prefix, ...args),
		warn: (...args: any[]) => logger.warn(prefix, ...args),
		error: (...args: any[]) => logger.error(prefix, ...args),
	};
}
